const CST_TIME_ZONE = "America/Chicago";

const MONTHS_SHORT = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

function formatDateParts(day, monthIndex, year) {
  const dd = String(day).padStart(2, "0");
  const mon = MONTHS_SHORT[monthIndex] || "";
  return `${dd}-${mon}-${year}`;
}

export function formatDate(value, fallback = "-") {
  if (value == null || value === "") return fallback;
  const raw = String(value).trim();

  const ymdMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (ymdMatch) {
    const year = Number(ymdMatch[1]);
    const monthIndex = Number(ymdMatch[2]) - 1;
    const day = Number(ymdMatch[3]);
    return formatDateParts(day, monthIndex, year);
  }

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return raw;

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: CST_TIME_ZONE,
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).formatToParts(parsed);
  const byType = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  const day = Number(byType.day || 0);
  const year = Number(byType.year || 0);
  const monthIndex = MONTHS_SHORT.indexOf(String(byType.month || "").toUpperCase());
  if (!day || !year || monthIndex < 0) return raw;
  return formatDateParts(day, monthIndex, year);
}

export function formatDateTime(value, fallback = "-") {
  if (value == null || value === "") return fallback;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return String(value);

  const dateParts = new Intl.DateTimeFormat("en-US", {
    timeZone: CST_TIME_ZONE,
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).formatToParts(parsed);
  const dateByType = Object.fromEntries(dateParts.map((part) => [part.type, part.value]));
  const day = Number(dateByType.day || 0);
  const year = Number(dateByType.year || 0);
  const monthIndex = MONTHS_SHORT.indexOf(String(dateByType.month || "").toUpperCase());
  if (!day || !year || monthIndex < 0) return String(value);
  const datePart = formatDateParts(day, monthIndex, year);

  const timeParts = new Intl.DateTimeFormat("en-US", {
    timeZone: CST_TIME_ZONE,
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).formatToParts(parsed);
  const byType = Object.fromEntries(timeParts.map((part) => [part.type, part.value]));
  const dayPeriod = String(byType.dayPeriod || "").toLowerCase();
  return `${datePart} ${byType.hour}:${byType.minute} ${dayPeriod}`.trim();
}
